import React, { useEffect, useState } from "react";
import Controls from "../../../../components/form/controls/Controls";

const statusOptions = [
  {
    id: "all",
    name: "all",
  },
  {
    id: "init",
    name: "init",
  },

  {
    id: "active",
    name: "active",
  },
  {
    id: "blocked",
    name: "blocked",
  },
];

const DeviceStatusFilter = ({ onStatusChange }) => {
  const [statusFilter, setStatusFilter] = useState("all");

  const handleFilterStatus = (e) => {
    const { value } = e.target;
    setStatusFilter(value);
  };

  useEffect(() => {
    // Gọi callback mỗi khi statusFilter thay đổi
    onStatusChange(statusFilter);
  }, [statusFilter, onStatusChange]);

  return (
    <Controls.Select
      name="statusFilter"
      label="Activation status"
      style={{ width: "120px" }}
      value={statusFilter}
      onChange={handleFilterStatus}
      options={statusOptions}
    />
  );
};

export default DeviceStatusFilter;
